import { useState } from "react";
import Step1 from "./components/Step1";
import LivePreview from "./components/LivePreview";
import { CheckIcon, TicketIcon } from "lucide-react";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";

const INITIAL_STEPS = [
  {
    label: "Email address verified",
    isCompleted: true,
  },
  {
    label: "Complete basic profile",
    isCompleted: false,
  },
];

const CreateBasicProfile = () => {
  const [steps, setSteps] = useState(INITIAL_STEPS);

  return (
    <div className="flex flex-col flex-1 rounded-md gap-5 p-5">
      <div className="flex items-center gap-3 h-12 px-2 bg-white rounded-md">
        {steps?.map((step, stepIndex) => {
          return (
            <button
              className={`flex items-center justify-center gap-2 py-1 rounded-full px-1 border cursor-pointer ${step?.isCompleted ? "bg-green-100 text-green-600" : "text-blue-600 bg-blue-50"}`}
            >
              <div className="flex items-center justify-center bg-white rounded-full h-5 w-5 border">
                {step?.isCompleted ? (
                  <CheckIcon size={12} />
                ) : (
                  <span className="font-semibold text-xss">
                    {stepIndex + 1}
                  </span>
                )}
              </div>
              <span className="font-semibold text-xss">{step?.label}</span>
            </button>
          );
        })}
      </div>
      {/* Main body */}
      <div className="flex flex-1 min-h-0 gap-5">
        {/* Profile setup */}
        {/* <Step1 /> */}
        {/* <Step2/> */}
        <Step3/>
        {/* Live profile preview */}
        <LivePreview />
      </div>
    </div>
  );
};

export default CreateBasicProfile;
